export const toRem = (pixels: number, rootFontSize = 16): string => {
  return `${pixels / rootFontSize}rem`;
};
